import React from 'react';
import { Button } from '@lendi-ui/button';
import { Check, PageNotFound } from '@lendi-ui/fancy-icon';
import Modal from '@lendi-ui/modal';
import { Body, Heading } from '@lendi-ui/typography';

import { useAnalytics } from '@funnels/providers';
import { run } from '@funnels/utils';

import { Content } from '../style';
import { IconContainer } from './index.style';

export interface ModalProps {
  isVisible: boolean;
  body: string;
  onHide: () => void;
  onClick: () => void;
}
interface BaseModalProps extends ModalProps {
  icon: React.ReactNode;
  title: string;
  buttonText: string;
}

function BaseModal(props: BaseModalProps) {
  const { tracking } = useAnalytics();
  return (
    <Modal role="dialog" isVisible={props.isVisible} size="md" onHide={props.onHide} isHeaderFixed>
      <Modal.Content>
        <Content>
          <IconContainer>{props.icon}</IconContainer>
          <Heading size="sm" mb="md" mt="sm">
            {props.title}
          </Heading>
          <Body>{props.body}</Body>
        </Content>
      </Modal.Content>
      <Modal.Footer>
        <Button
          variant="primary"
          data-component="modal-success-button"
          onClick={run(props.onClick, () =>
            tracking?.button.primary({ text: props.buttonText, position: props.title })
          )}
          isFullWidth
        >
          {props.buttonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export function Success(props: ModalProps) {
  return (
    <BaseModal
      {...props}
      icon={<Check width="72px" height="72px" />}
      title="Success!"
      buttonText="Return to dashboard"
    />
  );
}

export function Error(props: ModalProps) {
  return (
    <BaseModal
      {...props}
      icon={<PageNotFound width="72px" height="72px" />}
      title="Something's missing"
      buttonText="Ok"
    />
  );
}
